export type GeoStreamRuntimeConfig = {
  apiBaseUrl: string;
  tenantId: string;
  webClientId: string;
  apiClientId: string;
};

declare global {
  interface Window {
    __GEOSTREAM_CONFIG__?: Partial<GeoStreamRuntimeConfig>;
  }
}

export function runtimeConfig(): GeoStreamRuntimeConfig {
  const value = window.__GEOSTREAM_CONFIG__ || {};
  const development = import.meta.env.DEV ? {
    apiBaseUrl: import.meta.env.VITE_GEOSTREAM_API_BASE_URL,
    tenantId: import.meta.env.VITE_GEOSTREAM_TENANT_ID,
    webClientId: import.meta.env.VITE_GEOSTREAM_WEB_CLIENT_ID,
    apiClientId: import.meta.env.VITE_GEOSTREAM_API_CLIENT_ID,
  } : {};
  return {
    apiBaseUrl: value.apiBaseUrl?.replace(/\/$/, "") || development.apiBaseUrl?.replace(/\/$/, "") || "",
    tenantId: value.tenantId || development.tenantId || "",
    webClientId: value.webClientId || development.webClientId || "",
    apiClientId: value.apiClientId || development.apiClientId || "",
  };
}
